import { render, staticRenderFns } from "./OutfitsList.vue?vue&type=template&id=c6bdc54c&scoped=true"
import script from "./OutfitsList.vue?vue&type=script&lang=js"
export * from "./OutfitsList.vue?vue&type=script&lang=js"
import style0 from "./OutfitsList.vue?vue&type=style&index=0&id=c6bdc54c&prod&lang=scss&scoped=true"
import style1 from "./OutfitsList.vue?vue&type=style&index=1&id=c6bdc54c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6bdc54c",
  null
  
)

export default component.exports